import { Controller } from '@hotwired/stimulus'

// Sélection rapide des catégories marchandes d'une catégorie (admin). La recherche filtre la
// liste : espace = ET, | = OU, accents ignorés ; les boutons agissent sur les cases affichées.
export default class extends Controller {
  static targets = ['query', 'info', 'group', 'row', 'groupCount']

  connect() {
    this.rowTargets.forEach(row => { row.dataset.search = this.normalize(row.dataset.search) })
    this.filter()
  }

  filter() {
    const terms = this.terms()
    const filtering = terms.length > 0
    this.rowTargets.forEach(row => {
      row.hidden = filtering && !terms.every(re => re.test(row.dataset.search))
    })
    this.groupTargets.forEach(group => {
      const shown = group.querySelectorAll('[data-category-picker-target="row"]:not([hidden])').length
      group.hidden = shown === 0
      // Replié par défaut ; un filtre déplie les domaines qui ont des résultats.
      group.open = filtering && shown > 0
    })
    this.count()
  }

  check() { this.apply(this.shown(), () => true) }

  uncheck() { this.apply(this.shown(), () => false) }

  submitOnEnter(event) {
    if (event.key !== 'Enter') return
    event.preventDefault()
    this.check()
  }

  count() {
    const boxes = this.boxes()
    const checked = boxes.filter(box => box.checked).length
    const shown = this.terms().length > 0 ? this.shown().length : null
    this.infoTarget.textContent = [shown === null ? null : `${shown} affichée${shown > 1 ? 's' : ''}`,
      `${checked} cochée${checked > 1 ? 's' : ''} sur ${boxes.length}`].filter(Boolean).join(' · ')
    this.groupCountTargets.forEach(badge => {
      const n = badge.closest('details').querySelectorAll('input[type="checkbox"]:checked').length
      badge.textContent = `${n}/${badge.dataset.total}`
      badge.toggleAttribute('data-checked', n > 0)
    })
  }

  // Les cases de la recherche en cours ; aucune sans recherche, pour ne jamais tout cocher d'un clic.
  shown() {
    if (this.terms().length === 0) return []
    return this.rowTargets.filter(row => !row.hidden).map(row => this.box(row))
  }

  terms() {
    const query = this.normalize(this.queryTarget.value.trim())
    if (!query) return []
    try {
      return query.split(/\s+/).map(term => new RegExp(term, 'i'))
    } catch {
      return []
    }
  }

  apply(boxes, value) {
    boxes.forEach(box => { box.checked = value(box) })
    this.count()
  }

  boxes() {
    return this.rowTargets.map(row => this.box(row))
  }

  box(row) {
    return row.querySelector('input[type="checkbox"]')
  }

  normalize(text) {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
  }
}
